import { createSlice, combineReducers, createAsyncThunk } from '@reduxjs/toolkit'
import { AMLUser } from '@lk/api'

import {
  loadAMLUnslUsers,
  loadAMLZoneUsers,
  loadAMLExternals,
  loadAMLCRA,
  loadAMLRiskLevels,
  loadAMLAlerts,
  loadAMLRiskOperations,
} from './aml.actions'

export interface AMLUsersState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  data: AMLUser[]
}

const initialAMLUsersState: AMLUsersState = {
  status: 'idle',
  error: null,
  data: [],
}

export const createAMLUsersSlice = (name: string, asyncAction: ReturnType<typeof createAsyncThunk>) => {
  return createSlice({
    name,
    initialState: initialAMLUsersState,
    reducers: {},
    extraReducers: {
      [asyncAction.pending.toString()]: (state) => {
        state.status = 'loading'
      },
      [asyncAction.fulfilled.toString()]: (state, action) => {
        state.status = 'loaded'
        state.data = action.payload
      },
      [asyncAction.rejected.toString()]: (state, action) => {
        state.status = 'failed'
        state.error = action.payload
      },
    },
  }).reducer
}

export const amlReducer = combineReducers({
  unslUsers: createAMLUsersSlice('unslUsers', loadAMLUnslUsers),
  zoneUsers: createAMLUsersSlice('zoneUsers', loadAMLZoneUsers),
  externals: createAMLUsersSlice('externals', loadAMLExternals),
  riskOperations: createAMLUsersSlice('riskoper', loadAMLRiskOperations),
  alerts: createAMLUsersSlice('alerts', loadAMLAlerts),
  cra: createAMLUsersSlice('cra', loadAMLCRA),
  riskLevels: createAMLUsersSlice('risklevels', loadAMLRiskLevels),
})
